import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import Vuetify from '@/plugins/vuetify'
import store from '..'

@Module
export default class ThemesStore extends VuexModule {
    /* eslint-disable @typescript-eslint/no-explicit-any */

    currentTheme = 'default'
    loadingTheme = false
    customThemes: any[] = [
        {
            name: 'Entel',
            isDark: true,
            colors: {
                primary: '#ff0000',
                secondary: '#ff0000',
                accent: '#ff0000',
                info: '#ff0000',
                warning: '#ff0000',
                error: '#ff0000',
                success: '#ff0000',
                background: '#f00'
            }
        },
        {
            name: 'Claro',
            isDark: false,
            colors: {
                primary: '#00ff00',
                secondary: '#00ff00',
                accent: '#00ff00',
                info: '#00ff00',
                warning: '#00ff00',
                error: '#00ff00',
                success: '#00ff00',
                background: '#f00'
            }
        }
    ]

    @Mutation
    changeLoadingState (newBool: boolean) {
        this.loadingTheme = newBool
    }

    @Mutation
    changeTheme (theme: any) {
        this.currentTheme = theme.name

        if (theme.isDark) {
            Vuetify.framework.theme.themes.dark = theme.colors
            Vuetify.framework.theme.dark = true
        }
        if (!theme.isDark) {
            Vuetify.framework.theme.themes.light = theme.colors
            Vuetify.framework.theme.dark = false
        }
    }

    @Action
    setTheme (themeName: string) {
        return new Promise(resolve => {
            store.commit('changeLoadingState', true)
            setTimeout(() => {
                store.commit('changeTheme', store.state.ThemesStore.customThemes.find((t: any) => t.name === themeName))
                resolve()
                store.commit('changeLoadingState', false)
            }, 1000)
        })
    }
}
